"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var ProductDetailsWrapper = function ProductDetailsWrapper(_ref) {
  var hasProduct = _ref.hasProduct,
      children = _ref.children;
  return hasProduct ? /*#__PURE__*/_react["default"].createElement(_material.Box, {
    width: 1,
    height: 1
  }, children) : /*#__PURE__*/_react["default"].createElement(_material.Box, {
    textAlign: "center",
    mt: 4,
    fontSize: 24,
    lineHeight: 1.33,
    color: "text.main"
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, null, "No data"));
};

var _default = /*#__PURE__*/(0, _react.memo)(ProductDetailsWrapper);

exports["default"] = _default;